export default "__VITE_ASSET__BcC01PkB__"